import React from 'react'
import { Avatar, Badge, Button, Card, List, Typography, Empty } from 'antd'
import { BellOutlined, InboxOutlined } from '@ant-design/icons'
import dashboardStyles from '../styles/dashboardStyles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'

const { Text } = Typography

const NotificationsWidget = ({ notifications = [], onMarkAllRead }) => {
  // Custom empty state component
  const EmptyNotifications = () => (
    <div style={{ textAlign: 'center', padding: '24px 0' }}>
      <div
        style={{
          fontSize: '48px',
          color: '#1890ff',
          margin: '0 auto 16px',
          opacity: 0.7
        }}
      >
        <FontAwesomeIcon icon={faBell} />
      </div>
      <Text style={{ fontSize: '16px', color: '#8c8c8c' }}>No new notifications</Text>
      <div style={{ marginTop: '8px' }}>
        <Text type='secondary' style={{ fontSize: '14px' }}>
          You're all caught up!
        </Text>
      </div>
    </div>
  )

  return (
    <Card
      title='Recent Notifications'
      extra={
        <Button type='link' onClick={onMarkAllRead}>
          Mark All Read
        </Button>
      }
      style={dashboardStyles.card}
    >
      {notifications.length > 0 ? (
        <List
          itemLayout='horizontal'
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item style={{ opacity: item.read ? 0.7 : 1 }}>
              <List.Item.Meta
                avatar={
                  <Badge dot={!item.read}>
                    <Avatar icon={<BellOutlined />} style={{ backgroundColor: item.read ? '#d9d9d9' : '#1890ff' }} />
                  </Badge>
                }
                title={<Text strong={!item.read}>{item.message}</Text>}
                description={item.time}
              />
            </List.Item>
          )}
        />
      ) : (
        <EmptyNotifications />
      )}
    </Card>
  )
}

export default NotificationsWidget
